import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  TextField,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  IconButton,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import register from "../../../assets/images/home-page-images/Register.png";
import logoHeader from "assets/images/home-page-images/TavloAI.png";
import {Link, NavLink,useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleLogin } from '@react-oauth/google';
import { googleLoginUserAsync } from "features/actions/auth";
import { registerUserAsync } from "features/actions/auth";
import { registerCrmUserAsync } from "features/actions/auth";
import { clearRegister } from "features/reducers/auth";
import { clearGoogleAddress } from "features/reducers/auth";
import { GoogleSearchAysnc } from "features/actions/auth";
import Loader from "assets/loader/loader";
import MDButton from "components/MDButton";
import ReCAPTCHA from "react-google-recaptcha";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getAllRestaurants, googleAddress, registerData } = useSelector(
    (state) => state.auth
  );
   const [isLocalhost, setIsLocalhost] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [businessNameHint, setBusinessNameHint] = useState([]);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [googleApiCall, setGoogleApiCall] = useState(false);

  // Google Login function (from Landing.js)
  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      try {
        setLoading(true);
        await dispatch(googleLoginUserAsync(tokenResponse.access_token));
        navigate("/dashboard");
      } catch (error) {
        console.log(error);
      }
    },
    onNonOAuthError: () => {
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
      console.log(error);
    }
  });
   
  const [values, setValues] = useState({
    email: "",
    first_name: "Tavlo",
    last_name: "User",
    username:"",
    password: "",
    confirmPassword: "",
    phone_number: "",
    businessName: "",
    business_address: "",
    business_google_page: "",
    business_yelp_page: "",
    business_fb_page: "",
    business_twitter_page: "",
  });

const [crmValues, setcrmValues] = useState({
   first_name: "Tavlo",
    last_name: "Owner",
    emailAddress: "",
    userName:"",
    password:"",
    passwordConfirm:"",
    rolesIds: ["68a742885cfd0e050"],
    rolesNames: { "68a742885cfd0e050": "owner" }  })

  const [filterDataClose, setFilterDataClose] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    confirmPassword: "",
    phone_number: "",
    businessName: "",
    business_address: "",
    business_google_page: "",
    business_yelp_page: "",
    business_fb_page: "",
    business_twitter_page: "",
  });

  const checkName = /^[a-zA-Z\s]+$/;
  const checkEmail = /\S+@\S+\.\S+/;
  const checkPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).*$/;
  const checkUrl =
    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/;
  const checkPhoneNumber = /^(\+\d{1,3}[- ]?)?\d{10}$/;

  const eyeButton = () => {
    setShowPassword(!showPassword);
  };

  const eyeButton2 = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCaptchaChange = (value) => {
    setIsCaptchaVerified(true);
  };

  const handleRemoveMaskingChars = (phone_number) => {
    const cleanedPhoneNumber = phone_number.replace(/\D/g, ""); // Remove non-numeric characters
    return cleanedPhoneNumber;
  };

  const validateForm = (formData) => {
    const newErrors = {};

    const trimmedEmail = formData?.email?.trim();
    const trimmedPassword = formData?.password?.trim();
    const trimmedFirstName = formData?.first_name?.trim();
    const trimmedLastName = formData?.last_name?.trim();
    // Validate email
    if (!trimmedEmail) {
      newErrors.email = "Email is required";
    } else if (!checkEmail.test(trimmedEmail)) {
      newErrors.email = "Invalid email format";
    }

    // Validate name
    if (!trimmedFirstName) {
      newErrors.first_name = "First name is required";
    } else if (!checkName.test(trimmedFirstName)) {
      newErrors.first_name = "First name must be in alphabetic characters";
    }

    if (!trimmedLastName) {
      newErrors.last_name = "Last name is required";
    } else if (!checkName.test(trimmedLastName)) {
      newErrors.last_name = "Last name must be in alphabetic characters";
    }

    // Validate password
    if (!trimmedPassword) {
      newErrors.password = "Password is required.";
    } else if (!checkPassword.test(trimmedPassword)) {
      newErrors.password = "Password format is incorrect";
    } else if (trimmedPassword.length < 8) {
      newErrors.password = "Minimum 8 characters required";
    }

    // Validate Confirm Password
    if (!values.confirmPassword && values.password && errors.password === "") {
      newErrors.confirmPassword = "Confirm Password is required.";
    } else if (
      !(values.confirmPassword === values.password) &&
      values.password &&
      errors.password === ""
    ) {
      newErrors.confirmPassword = "Password doesn't match.";
    }

    // Validate phone number
    if (!values.phone_number) {
      newErrors.phone_number = "Phone number is required.";
    }
    if (
      values.phone_number &&
      !checkPhoneNumber.test(handleRemoveMaskingChars(values.phone_number))
    ) {
      newErrors.phone_number =
        "Please enter a numeric phone number with at least 10 digits.";
    }

    return newErrors;
  };

  const inputHandler = (fieldName) => {
    return (e) => {
      const { name, value } = e.target;
      let error = "";

      switch (fieldName) {        
        case "email":
        if (!value) {
          error = "Email is required";
        } else if (!checkEmail.test(value)) {
          error = "Invalid email format";
        } else {
          const namePart = value.split("@")[0];
          const randomNum = Math.floor(10000 + Math.random() * 90000);
          const generatedUsername = `${namePart}${randomNum}`.toLowerCase();
          const generatedPassword = `${generatedUsername}`.toLowerCase();

         setcrmValues((prev) => {
        const updated = {
          ...prev,
          emailAddress: value,
          userName: generatedUsername,
          password: generatedPassword,
          passwordConfirm: generatedPassword,
        };
      
        return updated;
      });
        setValues((prev) => {
         const updated = {
           ...prev,
           username: generatedUsername,
         };
      
         return updated;
      });
        } 
          break;
        case "first_name":
          if (!value) {
            error = "First name is required";
          } else if (!checkName.test(value)) {
            error = "First name must be in alphabetic characters";
          }
          break;
        case "last_name":
          if (!value) {
            error = "Last name is required";
          } else if (!checkName.test(value)) {
            error = "Last name must be in alphabetic characters";
          }
          break;
        case "password":

          if (value && !checkPassword.test(value)) {
            error = "Password format is incorrect";
          } else if (value.length < 8) {
            error = "Minimum 8 characters required";
          }
          break;
        case "confirmPassword":
          if (!value && !(value === values.password)) {
            error = "Confirm Password is required.";
          } else if (!(value === values.password)) {
            error = "password doesn't match.";
          }
          break;
        case "phone_number":
          if (
            value &&
            !checkPhoneNumber.test(handleRemoveMaskingChars(value))
          ) {
            error =
              "Please enter a numeric phone number with at least 10 digits.";
          }
          break;
        case "businessName":
          if (!value) {
            error = "Business Name is required.";
          } else {
            setFilterDataClose(false);
          }
          break;
        case "business_address":
          if (!value) {
            error = "Business Address is required.";
          }
          break;
        case "business_google_page":
        case "business_yelp_page":
        case "business_fb_page":
        case "business_twitter_page":
          if (value && !checkUrl.test(value)) {
            error = "Invalid URL format";
          }
          break;
        default:
          break;
      }

      setErrors({ ...errors, [fieldName]: error });
      setValues((prev) => ({ ...prev, [fieldName]: value }));

      // setValues({ ...values, [fieldName]: value });
      setcrmValues((prev) => ({ ...prev, [fieldName]: value }));    };
  };

  const handleSubmit = async () => {
    console.log(crmValues, "crmValues")

    const errors = validateForm(values);
    if (Object.keys(errors).length !== 0) {
      setLoading(true);
      const formDataObject = new FormData();
      // Append trimmed and validated values to formDataObject
      Object.keys(values).forEach((key) => {
        formDataObject.append(key, values[key].trim());
      });

      try {
        await dispatch(registerUserAsync(formDataObject));
        await dispatch(registerCrmUserAsync(crmValues));

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    } else {
      setErrors(errors);
    }
  };

  useEffect(() => {
    if (registerData.status_code == 200) {
      localStorage.setItem("email", values.email);
      dispatch(clearRegister());
      dispatch(clearGoogleAddress());
      navigate("/thank-you");
    }
  }, [registerData]);

  useEffect(() => {
    if (!filterDataClose && values.businessName != "") {
      let filteredRestaurants =
        values.businessName != "" &&
        getAllRestaurants?.filter((restaurant) =>
          restaurant.toLowerCase().includes(values.businessName.toLowerCase())
        );
      setBusinessNameHint(filteredRestaurants);
    }
  }, [filterDataClose, values]);

  useEffect(() => {
    if (filterDataClose && values.businessName != "" && !googleApiCall) {
      dispatch(GoogleSearchAysnc(values.businessName));
      setGoogleApiCall(true);
    }
  }, [values, filterDataClose]);

  useEffect(() => {
    if (googleAddress.status == "OK") {
      setValues({
        ...values,
        business_address: googleAddress.results[0].formatted_address,
      });
    }
  }, [googleAddress]);


  useEffect(() => {
    const isLocal =
      window.location.hostname === "localhost" 
    setIsLocalhost(isLocal);
  }, []);



  return (
    <MDBox
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      {loading && <Loader />}
      <Grid container sx={{ marginleft: "10px" }}>
        <Grid
          item
          md={6}
          px={0}
          sx={{
            py: 1.5,
            px: 2,
            display: "flex",
            justifyContent: "space-between",
            "@media(max-width:400px)": { px: 0, py: 2 },
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MDBox sx={{ width: "100%", textAlign: "start" }}>
              <MDBox
                sx={{
                  zIndex: "4",
                  width: "120px",

                  "@media (min-width:768px)": { width: "190px" },
                }}
              >
                <NavLink to="/">
                  <MDBox
                    component="img"
                    src={logoHeader}
                    alt="background"
                    sx={{
                      width: {
                        xs: "117px",
                        sm: "95%",
                        md: "100%",
                      },

                      height: {
                        xs: "26px",
                        sm: "657px",
                        md: "auto",
                      },
                      ml: {
                        xs: 2,
                        sm: 0,
                        md: 0,
                      },
                    }}
                  />
                </NavLink>
              </MDBox>
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>

      <MDBox
        sx={{
          maxHeight: "700px",
          height: {
            xs: "700px",
            sm: "100vh",
            md: "87.7vh",
          },
          width: "100vw",
          backgroundImage: `url(${register})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Blur background overlay */}

        {/* Form Card */}
        <Paper
          elevation={4}
          sx={{
            position: "relative",
            mx: {
              xs: 4,
              sm: 2,
              md: 0,
            },
            zIndex: 1,
            px: {
              xs: 4,
              sm: 7,
              md: 7,
            },
            py: 2,
            borderRadius: "10px",
            backdropFilter: "blur(10px)",
            border: "2px solid #777777ff",
            // borderImageSource:
            //   "linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.08) 50%)",
            // borderImageSlice: 1,
            maxWidth: 400,
            width: "100%",
            backgroundColor: "rgba(100, 100, 100, 0.3)",
          }}
        >
          <MDTypography
            align="center"
            gutterBottom
            sx={{
              color: "#fff",
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "32px",
            }}
          >
            Register
          </MDTypography>

          <MDBox component="form" onSubmit={handleSubmit} noValidate sx={{}}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              id="standard-basic"
              variant="standard"
              margin="dense"
               value={values.name}
               error={!!errors.name}
               onChange={inputHandler("name")}
              helperText={errors.name}
              autoComplete="off"
             sx={{
                mt: 0,
                mb: 1,
                "& .MuiInputLabel-root": {
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 600,
                  transform: "translate(0, 30px) scale(1)",
                },
                "& .MuiInputLabel-shrink": {
                  transform: "translate(0, 4px) scale(0.85)",
                  color: "#fff !important", 
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff !important", 
                },
                "& .MuiInputBase-root": {
                  fontSize: "12px",
                  color: "#fff",
                  "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px transparent inset",
                    WebkitTextFillColor: "#fff",
                    transition: "background-color 5000s ease-in-out 0s",
                  },
                },
              }}
              InputProps={{
                style: { fontSize: 15, color: "#fff" },
                endAdornment: (
                  <InputAdornment position="end">
                    <PersonIcon sx={{ color: "#fff" }} htmlColor="white" />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              name="email"
              label="Email"
              id="standard-basic"
              variant="standard"
              margin="dense"
              value={values.email}
               error={!!errors.email}
               onChange={inputHandler("email")}
              helperText={errors.email}
              autoComplete="off"
              sx={{
                mt: 0,
                mb: 2,
                "& .MuiInputLabel-root": {
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 600,
                  transform: "translate(0, 30px) scale(1)",
                },
                "& .MuiInputLabel-shrink": {
                  transform: "translate(0, 4px) scale(0.85)",
                  color: "#fff !important", 
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff !important", 
                },
                "& .MuiInputBase-root": {
                  fontSize: "12px",
                  color: "#fff",
                  "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px transparent inset",
                    WebkitTextFillColor: "#fff",
                    transition: "background-color 5000s ease-in-out 0s",
                  },
                },
              }}
              InputProps={{
                style: { fontSize: 15, color: "#fff" },
                endAdornment: (
                  <InputAdornment position="end">
                    <MailIcon sx={{ color: "#fff" }} htmlColor="white" />
                  </InputAdornment>
                ),
              }}
            />
            <MDBox
                  item
                  xs={12}
                  lg={12}
                  sx={{ alignSelf: "start", justifyContent: "center" }}
              >
                  {!isLocalhost && (
                      <ReCAPTCHA
                          sitekey="6Ldp3lspAAAAAPZoobA6vLHHHOnWa4eTm9B-GyxB"
                          onChange={handleCaptchaChange}
                      />
                  )}
            </MDBox>

 <MDBox>
             <MDButton
               variant="gradient"
                sx={{
                cursor: "Pointer",
                width: "100%",
                border: "none",
                mt: 0.5,
                textAlign: "center",
                fontSize: "12px",
                fontFamily: "Poppins",
                color: "#000",
                backgroundColor: "#fff",
                textTransform: "capitalize",
                fontWeight: 600,
                py: 1,
                borderRadius: "6px",
                 "&:hover": {
                  background: "#fff",
                  },
                 }}
                onClick={() => handleSubmit()}
                 fullWidth 
                 >
                  Continue
                </MDButton>
              </MDBox>

            <MDBox
              sx={{
                textAlign: "center",
                fontSize: "10px",
                // textTransform: "uppercase",
                my: 1,
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#fff",
              }}
            >
              OR
            </MDBox>

            <MDButton
             onClick={() => {setLoading(true); login()}}
               sx={{
               background:
                 "linear-gradient(90deg, #DB4437 0%, #F4B400 30%, #0F9D58 60%, #4285F4 100%)",
               cursor: "Pointer",
               width: "100%",
               border: "none",
               textAlign: "center",
               fontSize: "12px",
               fontFamily: "Poppins",
               color: "#fff",
               backgroundColor: "#fff",
               textTransform: "capitalize",
               fontWeight: 600,
               py: 1,
               borderRadius: "6px",
             }}
             >
             &nbsp; Continue with Google
           </MDButton>
          </MDBox>

          <MDTypography
            variant="body2"
            align="center"
            sx={{
              mt: 3,
              color: "text.secondary",
              color: "#fff",
              fontSize: "10px",
              fontFamily: "Poppins",
            }}
          >
            Already have an account?{" "}
            {/* <NavLink to="/login" style={{ textDecoration: "none" }}> */}
              <MDTypography
              component={Link}
                to="/sign-in"
                sx={{
                  display: "inline",
                  cursor: "pointer",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Login
              </MDTypography>
            {/* </NavLink> */}
          </MDTypography>
        </Paper>
      </MDBox>
    </MDBox>
  );
};

export default Register;
